import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { getConnectionStatus, getConnectionTimestamp } from '../reducers';
import { socketConnect } from '../actions/connection';

import { Close as CloseIcon } from './Icons';

import {
  SOCKET_CONNECTION_DISCONNECT,
  SOCKET_CONNECTION_RECONNECT,
} from '../constants/ActionTypes';

import { efficientSetInterval } from '../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    left: 0,
    width: '100vw',
    zIndex: 1200,
    top: '54px',
    height: '28px',
    fontSize: '0.87rem',

    [theme.breakpoints.up('md')]: {
      top: '60px',
    },

    '& .message': {
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#fff',
      padding: '0 24px',

      '&.danger': {
        backgroundColor: '#fa4c4c',
      },

      '&.safe': {
        backgroundColor: '#13a252',

        '& > div': {
          marginLeft: 'auto',
        },
      },

      '& .control': {
        fontSize: '17px',
        display: 'inline-flex',
        cursor: 'pointer',
      },
    },
  },
}));

function ConnectionNotifier({
  connectionStatus,
  messages,
  closeStatusMessage,
}) {
  const classes = useStyles();

  const statuses = {
    SOCKET_CONNECTION_DISCONNECT,
    SOCKET_CONNECTION_RECONNECT,
  };

  return (
    <>
      {connectionStatus && statuses[connectionStatus] ? (
        <div className={classes.root}>
          {connectionStatus === SOCKET_CONNECTION_DISCONNECT ? (
            <div className="message danger">
              <div>{messages.offline}</div>
            </div>
          ) : (
            <div className="message safe">
              <div>{messages.online}</div>
              <div className="control">
                <SvgIcon
                  component={CloseIcon}
                  fontSize="inherit"
                  onClick={closeStatusMessage}
                />
              </div>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}

ConnectionNotifier.propTypes = {
  loading: PropTypes.bool.isRequired,
};

class ConnectionNotifierBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      timeout: 5,
      messages: {
        online: 'You are back online',
        offline: 'You are disconnected, please refresh this page',
      },
    };

    this.handleCloseStatusMessage = this.handleCloseStatusMessage.bind(this);
  }

  componentDidMount() {
    efficientSetInterval(
      () => {
        const { timeout } = this.state;
        if (
          this.props.connectionStatus &&
          this.props.connectionStatus === SOCKET_CONNECTION_RECONNECT &&
          this.props.connectionTimestamp
        ) {
          const timeNow = moment().subtract(timeout, 'seconds');
          // remove nack online message
          if (moment(this.props.connectionTimestamp).isBefore(timeNow)) {
            this.props.socketConnect();
          }
        }
      },
      3000,
      { leading: true }
    );
  }

  handleCloseStatusMessage(e) {
    e.preventDefault();

    this.props.socketConnect();
  }

  render() {
    return (
      <ConnectionNotifier
        {...this.state}
        {...this.props}
        closeStatusMessage={this.handleCloseStatusMessage}
      />
    );
  }
}

ConnectionNotifierBase.defaultProps = {
  connectionStatus: '',
  connectionTimestamp: '',
};

ConnectionNotifierBase.propTypes = {
  connectionStatus: PropTypes.string,
  connectionTimestamp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const mapStateToProps = (state) => {
  return {
    connectionStatus: getConnectionStatus(state),
    connectionTimestamp: getConnectionTimestamp(state),
  };
};

export default connect(mapStateToProps, {
  socketConnect,
})(ConnectionNotifierBase);
